import { useState } from 'react';
import { daysInPeriod, IPackage } from 'entities/mine-package/model';

export interface UseCalculatorProps {
  tap2minePackage: IPackage;
}

export const useCalculator = ({ tap2minePackage }: UseCalculatorProps) => {
  const [selectedPeriod, setSelectedPeriod] = useState(0);
  const [useX2, setUseX2] = useState(false);
  const currentPeriodDays = daysInPeriod[selectedPeriod];

  const profitUsd = (tap2minePackage.profitUSD[selectedPeriod] * (useX2 ? 2 : 1)).toFixed(2);
  const profitCrat = (tap2minePackage.daily.crat * currentPeriodDays * (useX2 ? 2 : 1)).toFixed(2);
  const profitCit = (tap2minePackage.daily.cit * currentPeriodDays * (useX2 ? 2 : 1)).toFixed(2);

  return {
    selectedPeriod,
    useX2,
    profitUsd,
    profitCrat,
    profitCit,
    setSelectedPeriod,
    setUseX2,
  };
};
